import {useState} from 'react';
import uuid from 'uuid';

/**
 * Generate a unique id that doesn't recompute each render.
 * Useful for adding labels for forms or a11y.
 * @returns {string}
 */
const useUniqueId = () => useState(uuid)[0];

export default useUniqueId;